import {ModuleWithProviders} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AuthorizedRouteFactory} from '@application/helper/routing/authorized-route-factory';
import {NavigationId} from '@application/helper/routing/navigation-id.enum';
import {Permission} from '@domain/profile/permission.enum';
import {MachineTypeOverviewPageComponent} from './overview/machine-type-overview-page.component';

const shared = {parentId: NavigationId.MACHINE_TYPE_MODULE};

export const machineTypeRoutes = [
  AuthorizedRouteFactory.createPrototypeComponentRoute(MachineTypeOverviewPageComponent, {
    route: '',
    requiredPermission: Permission.CONNECT_DEVELOPER,
    reuse: true,
    id: NavigationId.MACHINE_TYPE,
    ...shared
  })
];

export const machineTypeRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(machineTypeRoutes);
